import { ADMIN_PANEL_CLIENT_ID } from 'constants/auth';

export class RolesManagementApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getRoles({ skipForbiddenError, ...params } = {}) {
    return this.#http.get('/api/roles', {
      params,
      headers: { clientId: ADMIN_PANEL_CLIENT_ID },
      // A scoped broker viewing their own security-group claims is 403'd on the company-wide roles
      // list; skip the global forbidden-status page-reload interceptor so the page degrades instead
      // of reloading. Only affects the 403 path (a no-op on the employee 200 path).
      ...(skipForbiddenError && { skipResponseInterceptor: { forbiddenError: true } }),
    });
  }

  async editRole({ companyId, ...body }) {
    return this.#http.put(`/api/companies/${companyId}/roles/${body.id}`, body, {
      headers: { clientId: ADMIN_PANEL_CLIENT_ID },
    });
  }

  async createRole({ companyId, ...body }) {
    return this.#http.post(`/api/companies/${companyId}/roles`, body, {
      headers: { clientId: ADMIN_PANEL_CLIENT_ID },
    });
  }

  async copyRole({ companyId, id, name }) {
    return this.#http.post(
      `/api/companies/${companyId}/roles/${id}/copy`,
      { name },
      {
        headers: { clientId: ADMIN_PANEL_CLIENT_ID },
      },
    );
  }

  async deleteRole({ companyId, id }) {
    return this.#http.delete(`/api/companies/${companyId}/roles/${id}`, {
      headers: { clientId: ADMIN_PANEL_CLIENT_ID },
    });
  }
}
